import { CheckCircle2 } from "lucide-react";
import { motion } from "framer-motion";
import { pad2 } from "../lib/helpers";

/**
 * Atomic, reusable display primitives used by multiple sections of
 * the /free-screening page. Kept here so every section file is short.
 */

export function TrustPoint({ children }) {
  return (
    <div className="flex items-center gap-2 text-sm text-[#1F2933]">
      <CheckCircle2 className="h-5 w-5 text-[#14B8A6] shrink-0" />
      <span className="font-semibold">{children}</span>
    </div>
  );
}

export function SectionHeading({ overline, title, subtitle, center = false }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className={center ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}
    >
      {overline && (
        <p className="text-xs uppercase tracking-[0.18em] font-bold text-[#2F6F6A] mb-3">
          {overline}
        </p>
      )}
      <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#1F2933] leading-[1.1]">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}

export function CountdownUnit({ value, label }) {
  return (
    <div className="flex flex-col items-center">
      <div className="bg-white border-2 border-[#F4C430] rounded-lg shadow-sm w-10 h-10 sm:w-11 sm:h-11 flex items-center justify-center">
        <span className="font-display font-extrabold text-rose-600 text-base sm:text-lg tabular-nums">
          {pad2(value)}
        </span>
      </div>
      <span className="text-[9px] font-bold tracking-widest text-slate-600 dark:text-slate-400 mt-1">{label}</span>
    </div>
  );
}
